import PropTypes from 'prop-types';
import { Box, Chip, Stack, Typography } from '@mui/material';

/**
 * Standard page header used across all Gateway pages.
 * Children are rendered in a flex row on the right side (actions / filters).
 */
const PageHeader = ({ title, subtitle, storeLabel, storeIndicator, children }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: { xs: 'flex-start', md: 'center' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 2,
      mb: 3,
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      {typeof title === 'string' ? (
        <Typography variant="h2" sx={{ mb: 0.25 }}>{title}</Typography>
      ) : (
        title
      )}
      {storeIndicator && (
        <Box sx={{ mt: 0.5 }}>
          {storeIndicator}
        </Box>
      )}
      {storeLabel && !storeIndicator && (
        <Chip
          label={storeLabel}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ mt: 0.5, mb: 0.25, fontWeight: 600, fontSize: '0.8125rem' }}
        />
      )}
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {children && (
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
        sx={{ flexShrink: 0, width: { xs: '100%', md: 'auto' } }}
      >
        {children}
      </Stack>
    )}
  </Box>
);

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  storeLabel: PropTypes.string,
  storeIndicator: PropTypes.node,
  children: PropTypes.node,
};

export default PageHeader;
